import { MoreVert } from "@material-ui/icons";
import { useState } from "react";
import DownloadExcelNestedTable from "../../App/validation/DownloadExcelNestedTable";
import DownloadPdfNestedTable from "../../App/validation/DownloadPdfNestedTable";


export default function NESTED_TABLE_FLOAT_MENU (){
    const [isFloatMenu, setIsFloatMenu] = useState(false)

    return (
        <>
            <div 
                className="button_big button_white center_perfect"
                style={{position: "relative"}}
                onClick={() => {
                isFloatMenu ? setIsFloatMenu(false) : setIsFloatMenu(true)
            }}>
                <MoreVert/>
                {isFloatMenu && (
                    <div
                        style={{
                            position: "absolute",
                            display: "grid",
                            gridTemplateColumns: "repeat(2,1fr)",
                            gap: 10,
                            bottom: "100%",
                            right: "0",
                            zIndex: 9999999,
                            background: "#fff",
                            boxShadow: "0 2px 12px rgba(0, 0, 0, 0.15)",
                            borderRadius: "13px",
                            padding: "13px",
                            transformOrigin: "bottom right",
                            transition: "transform 180ms ease-out, opacity 180ms ease-out",
                            // transform: !isFloatMenu ? "scale(1)" : "scale(0.8)",
                            // opacity: !isFloatMenu ? 1 : 0,
                            // pointerEvents: !isFloatMenu ? "auto" : "none",
                        }}
                    >  
                        <DownloadExcelNestedTable/>
                        <DownloadPdfNestedTable/>
                    </div>
                    )
                }
            </div>
        </>
        
    )
}